import { Link } from 'react-router-dom';
import { site } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-content px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="grid grid-cols-2 w-9 h-9 rounded-md overflow-hidden">
                <span className="bg-primary-400" />
                <span className="bg-accent-400" />
                <span className="bg-background-100" />
                <span className="bg-secondary-400" />
              </span>
              <span className="font-heading text-2xl font-black text-background-50">
                {site.name}
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-secondary-200 max-w-md">
              {site.description}
            </p>
            <p className="mt-6 text-sm text-secondary-200">
              <i className="ri-mail-line mr-2 align-middle" aria-hidden="true" />
              投稿与合作：
              <a
                href={`mailto:${site.email}`}
                className="text-accent-300 hover:text-accent-200 underline underline-offset-4 ml-1"
              >
                {site.email}
              </a>
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-base text-background-50 mb-4">内容栏目</h3>
            <ul className="space-y-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-secondary-200 hover:text-accent-300 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-base text-background-50 mb-4">关于本站</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-secondary-200 hover:text-accent-300 transition-colors">
                  我们是谁
                </Link>
              </li>
              <li>
                <Link to="/about#principles" className="text-secondary-200 hover:text-accent-300 transition-colors">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-secondary-200 hover:text-accent-300 transition-colors">
                  联系与投稿
                </Link>
              </li>
              <li>
                <Link to="/" className="text-secondary-200 hover:text-accent-300 transition-colors">
                  返回首页
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-secondary-300">
            © {new Date().getFullYear()} {site.name}　{site.slogan}
          </p>
          <p className="text-xs text-secondary-300 flex items-center gap-2">
            <i className="ri-shield-check-line" aria-hidden="true" />
            尊重隐私边界 · 只呈现公开场景
          </p>
        </div>
      </div>
    </footer>
  );
}